module.exports = __webpack_public_path__ + "img/Image - Header 5@2x(2).f2d0afee.png";